'use strict';

var novicell = novicell || {};
novicell.search = novicell.search || function () {

    var searchIcon = document.querySelector('.js-search-input-trigger');
    var searchForm = document.querySelector('.js-search-form');
    var searchInput = document.querySelector('.js-search-input');

    function init() {
        // Open search form
        if(searchIcon != null) {
            searchIcon.addEventListener('click', function (e) {
                e.stopPropagation();
                openSearch();
            }, true);  
        }

        // Close search form when esc pressed
        if(searchInput != null) {
            searchInput.addEventListener('keyup', function (evt) {
                evt = evt || window.event;
                if (evt.keyCode === 27) {
                    closeSearch();
                }
            }, true);
        }

        // Close search form when click outsite form element
        if(searchForm != null) {
            document.addEventListener('click', function (e) {
                var clickOnBody = e.target != searchForm && e.target.parentNode.parentNode != searchForm ? true : false;
                if(searchForm.classList.contains('show-search-form') && clickOnBody){
                    closeSearch();
                }
            }, true);
        }
    }

    function openSearch() {
        searchForm.classList.toggle('show-search-form');
        searchInput.value = '';
        setTimeout(function(){
            searchInput.focus();
        }, 50); 
    }

    function closeSearch() {
        searchForm.classList.remove('show-search-form');
    }
    return {
        init:init
    };
}();
